// Phase 4.3 — Online Billing "change order status" panel.
//
// Replaces the antd <Drawer> status editor in onlineBilling.tsx with a shadcn
// <Sheet> + Select. Presentation only: the selected status and the save/cancel
// actions are the screen's (onStatusChange / onSave / onClose) — the
// updateOnlineOrderAction dispatch is unchanged.
import * as React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "ui/sheet";
import { Button } from "ui/button";
import { Label } from "ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "ui/select";

const STATUS_OPTIONS = [
  { id: 1, name: "New Order" },
  { id: 2, name: "In Transit" },
  { id: 3, name: "Delivered" },
  { id: 4, name: "Cancelled" },
  { id: 5, name: "Returned" },
];

export interface OnlineOrderStatusSheetProps {
  open: boolean;
  onClose: () => void;
  status: any;
  saving: boolean;
  onStatusChange: (status: number) => void;
  onSave: () => void;
}

export function OnlineOrderStatusSheet({
  open,
  onClose,
  status,
  saving,
  onStatusChange,
  onSave,
}: OnlineOrderStatusSheetProps) {
  return (
    <Sheet open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <SheetContent side="right" className="flex w-full flex-col gap-0 p-0 sm:max-w-sm">
        <SheetHeader className="border-b px-5 py-4">
          <SheetTitle>Online Order</SheetTitle>
        </SheetHeader>
        <div className="flex flex-1 flex-col gap-2 p-5">
          <Label>Select status</Label>
          <Select
            value={status != null ? String(status) : undefined}
            onValueChange={(v) => onStatusChange(Number(v))}
          >
            <SelectTrigger><SelectValue placeholder="Select status" /></SelectTrigger>
            <SelectContent>
              {STATUS_OPTIONS.map((item) => (
                <SelectItem key={item.id} value={String(item.id)}>{item.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex justify-end gap-2 border-t px-5 py-4">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button disabled={saving} onClick={onSave}>Save</Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}

export default OnlineOrderStatusSheet;
